import filesize from 'filesize'
import React, { ReactElement } from 'react'
import classes from './FileInfo.module.css'
import { FileIcon, FileLabel } from './FileType'

export type Props = {
    typ: string
    name: ReactElement | string
    groesse: number
    className?: string
}

export default function FileInfo({ name, typ, groesse, className }: Props) {
    return (
        <div className={`d-flex align-items-center ${className || ''}`}>
            <FileIcon type={typ} className={`mr-2 ${classes.icon}`} />
            <div className={classes.name}>
                {name}
                <br />
                <small>
                    <FileLabel type={typ} />, {filesize(groesse, { locale: 'de' })}
                </small>
            </div>
        </div>
    )
}
